module.exports = __webpack_public_path__ + "img/far-square.a070ce62.svg";